"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var internalSlotMap = new WeakMap();
function getInternalSlots(x) {
    var internalSlots = internalSlotMap.get(x);
    if (!internalSlots) {
        internalSlots = Object.create(null);
        internalSlotMap.set(x, internalSlots);
    }
    return internalSlots;
}
exports.default = getInternalSlots;



//////////////////
// WEBPACK FOOTER
// ./~/@formatjs/intl-pluralrules/get_internal_slots.js
// module id = 609
// module chunks = 2